export default "__VITE_ASSET__WXYKxiAu__"